import { ArrowDownIcon, FaroTextVariant, neutral, Text } from "@flat-ui";
import { ButtonBase, SxProps } from "@mui/material";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { SphereDropdownButtonProps } from "@components/common/dropdown/sphere-dropdown-selector-types";

interface Props extends SphereDropdownButtonProps {
  /** Text to display as tooltip on the drop-down button */
  buttonTooltipText?: string;

  /**
   * Defines the text style variant used for the dropdown label.
   *
   * @default FaroTextVariant.bodyM
   */
  variant?: FaroTextVariant;

  /**
   * Color of the icon.
   *
   * @default neutral[1000]
   */
  iconColor?: string;

  /** Custom style overrides for the main label text */
  sxLabel?: SxProps;
}

/**
 * Export button styled for selected items export.
 * Displays the label text followed by an arrow down icon that rotates when the menu is open.
 */
export function SphereDropdownButton({
  isOpen,
  onClick,
  label,
  buttonTooltipText,
  variant = FaroTextVariant.bodyM,
  iconColor = neutral[1000],
  sxLabel,
}: Props): JSX.Element {
  return (
    <SphereTooltip title={buttonTooltipText}>
      <ButtonBase
        sx={{
          gap: "0.375rem",
        }}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={onClick}
      >
        <Text
          variant={variant}
          sx={{
            ...sxLabel,
          }}
        >
          {label}
        </Text>
        <ArrowDownIcon
          data-testid="dropdown-selector-arrow"
          sx={{
            width: "1rem",
            height: "1rem",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out",
            color: iconColor,
          }}
        />
      </ButtonBase>
    </SphereTooltip>
  );
}
